import { AvisConcerne } from './../../models/AvisConcerne';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../../shared/models/component-messages/diveIN/step2';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn_DIVER_G1 } from '../../models/TypeAnn_DIVER_G1';
import { Step1 } from '../../../../../shared/models/component-messages/diveIN/step1';

@Component({
	selector: 'app-step1',
	templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {

	private LOG: LogService = new LogService(Step1Component);

	@Input() initial: TypeAnn_DIVER_G1;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	public current_uid = 'AvisConcerne';

	@Input() uid = '';

	public step1 = new Step1();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService
	) { }


	ngOnInit(): void {
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	  }

}
